import ActionTypes from '../Data/ActionTypes';

export const getSubmissionStatusAction = ({
  submissionId,
  iFrameId,
  token,
}) => {
  return {
    type: ActionTypes.GET_SUBMISSION_STATUS,
    payload: {
      submissionId,
      iFrameId,
      token,
    },
  };
};

export const getAppointmentsAction = ({
  postcode,
  country,
  provider,
  appointmentBookingPage,
  locale,
}) => {
  return {
    type: ActionTypes.GET_APPOINTMENTS,
    payload: { postcode, country, provider, appointmentBookingPage, locale },
  };
};

export const submitSelectAndConnectAction = ({ selectAndConnectPage }) => {
  return {
    type: ActionTypes.SUBMIT_SELECT_AND_CONNECT,
    payload: { selectAndConnectPage },
  };
};

export const clearSelectAndConnectNavigationBlocks = ({
  selectAndConnectPage,
}) => {
  return {
    type: ActionTypes.CLEAR_SELECT_AND_CONNECT_NAVIGATION_BLOCKS,
    payload: { selectAndConnectPage },
  };
};

export const getLegalStatementAction = ({
  subcategoryId,
  localeCode,
  supplierId,
  newsletters,
  includeSupplierLegalStatements,
}) => {
  return {
    type: ActionTypes.GET_LEGAL_STATEMENT,
    payload: {
      subcategoryId,
      localeCode,
      supplierId,
      newsletters,
      includeSupplierLegalStatements,
    },
  };
};

export const decryptCrmData = ({ payload }) => {
  return {
    type: ActionTypes.DECRYPT_CRM_DATA,
    payload: { payload },
  };
};

export const isDomainInternalSaga = ({ domain }) => {
  return {
    type: ActionTypes.IS_DOMAIN_INTERNAL,
    payload: { domain },
  };
};

export const getCustomerMatchesSaga = () => {
  return {
    type: ActionTypes.GET_CUSTOMER_MATCHES,
    payload: {},
  };
};

export const prepareSupplierMatchingSaga = () => {
  return {
    type: ActionTypes.PREPARE_SUPPLIER_MATCHING,
    payload: {},
  };
};

export const getSupplierCardLogosSaga = () => {
  return {
    type: ActionTypes.GET_SUPPLIER_CARD_LOGOS,
    payload: {},
  };
};

export const handleAnswerQuestionSideEffectsSaga = ({ componentId }) => {
  return {
    type: ActionTypes.HANDLE_ANSWER_QUESTION_SIDE_EFFECTS,
    payload: { componentId },
  };
};

export const getDynamicNewsletterSaga = ({
  visitorId,
  destinationPageNumber,
  fallbackNewsletter,
}) => {
  return {
    type: ActionTypes.GET_DYNAMIC_NEWSLETTER,
    payload: { visitorId, destinationPageNumber, fallbackNewsletter },
  };
};

export const getPlacePredictionsSaga = ({
  input,
  visitorId,
  regionCode,
  componentId,
  locationBias,
}) => {
  return {
    type: ActionTypes.GET_PLACE_PREDICTIONS,
    payload: { input, visitorId, regionCode, componentId, locationBias },
  };
};

export const handleGoogleAddressSelectedSaga = ({
  componentId,
  placeId,
  shouldPopulateUpcomingFields,
  inputValue,
  formId,
  iFrameId,
  visitorId,
}) => {
  return {
    type: ActionTypes.HANDLE_GOOGLE_ADDRESS_SELECTED,
    payload: {
      componentId,
      placeId,
      shouldPopulateUpcomingFields,
      inputValue,
      formId,
      iFrameId,
      visitorId,
    },
  };
};

export const handleZipcodeUpdatedSaga = ({
  componentId,
  postcode,
  country,
  formId,
  iFrameId,
}) => {
  return {
    type: ActionTypes.HANDLE_ZIP_CODE_PROVIDED,
    payload: {
      componentId,
      postcode,
      country,
      formId,
      iFrameId,
    },
  };
};

export const populateFormFieldSaga = ({
  countryCode,
  value,
  iFrameId,
  formId,
  component,
}) => {
  return {
    type: ActionTypes.POPULATE_FORM_FIELD,
    payload: { countryCode, value, iFrameId, formId, component },
  };
};
